import { SHOW_IN_MA_VACH_TAI_SAN } from "./actionTypes";

export const showInMaVachTaiSan = () => ({
  type: SHOW_IN_MA_VACH_TAI_SAN,
});
